export const EVENTS_SCHEMA_VERSION = "0.59.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.30.0";
